import {ATTRIBUTE_TYPE_NAME, AttributeType} from '../constants';

export const getTypeName = (type: AttributeType) => ATTRIBUTE_TYPE_NAME[type];

export default getTypeName;
